import axios from 'axios'
import Api from '@/conf/Api';

export default function notify(commit, e) {

    if (e.status && e.status < 300 && e.data && e.data.msg) 
        commit('general/SET_STATUS', { text: e.data.msg, color: 'green' }, { root: true })

    if (e.response) {
        let status = e.response.status

        if (status !== 404) {
            let error = e.response.data.msg || e.response.data.erro || e.erro

            if (status > 300 && status < 500) {
                commit('general/SET_STATUS', { text: error, color: 'orange' }, { root: true })
                commit('general/SET_NOTIFY', error, { root: true })
            }

            if (status > 499 || e.erro) {
                commit('general/SET_STATUS', { text: error, color: 'red' }, { root: true })
                commit('general/SET_NOTIFY', error, { root: true })
            }
        }

        // LOGOUT
        if (status == 401 && location.pathname != '/login') {
            axios.delete(Api.login.auth)
            localStorage.removeItem('state');
            window.location = '/'
        }
    }
}